// Module
var code = "<div ng-repeat=\"chars in $ctrl.columns track by $index\" class=\"bubbleColumn bubbleColumn--bordered\">\n    <span ng-repeat=\"char in chars track by $index\" class=\"bubble\" ng-bind=\"char === $ctrl.answerCharByColumn[$parent.$index] ? '\\uEEF2' : char\"></span>\n</div>\n";
// Exports
module.exports = code;